/* info-panel.tsx generated by @compiled/babel-plugin v0.17.1 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import React from "react";
import theme from "../theme";
var _6 = "._1wybdlk8{font-size:14px}";
var _5 = "._syaz1u6e{color:#cba6f7}";
var _4 = "._y3gn1h6o{text-align:center}";
var _3 = "._t9ec1i34{transform:translateY(-50%)}";
var _2 = "._154i1ssb{top:50%}";
var _ = "._kqswh2mm{position:relative}";
var infoPanelStyles = null;
var InfoPanel = function InfoPanel(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6]), /*#__PURE__*/React.createElement("div", {
    className: ax(["_kqswh2mm _154i1ssb _t9ec1i34 _y3gn1h6o _syaz1u6e _1wybdlk8"])
  }, children));
};
export { InfoPanel };